import React from 'react'
import { CheckCircle, Leaf, Handshake } from 'lucide-react'
import { useSelector } from 'react-redux';
function Apropos() {
    const langue = useSelector((state) => state.langue.value);
  
  return (
    <div className='bg-gray-300'>
      <div className="justify-center mb-2 mx-1 flex items-center">
        <div className="relative text-center text-white lg:w-[70%] lg:h-96 p-6 rounded-lg flex flex-col justify-center items-center overflow-hidden">
          {/* Image de fond avec flou */}
          <div
            className="absolute inset-0 bg-cover bg-center rounded-lg "
            style={{ backgroundImage: `url('https://res.cloudinary.com/dkxjl9qii/image/upload/v1740834387/posts/kyit6z0yki6gclhzxpeb.jpg')` }}
          ></div>

          {/* Contenu au premier plan */}
          <div className="relative z-10">
            <h1 className="text-xl lg:text-4xl font-bold">
              {langue === 'fr'
                ? 'Découvrez l\'authenticité des épices'
                : 'اكتشف أصالة التوابل'}
            </h1>
            <img className='h-32 w-32 lg:h-52 lg:w-52 m-auto'
              src="https://res.cloudinary.com/dkxjl9qii/image/upload/v1740503127/posts/pdpxxw1jrpmejjaqy76u.png" alt="" />
            <p className="text-lg lg:text-xl text-gray-200">
              {langue === 'fr'
                ? 'Qualité et saveurs venues d\'ailleurs, livrées chez vous.'
                : 'الجودة والنكهات القادمة من أماكن أخرى، يتم توصيلها إليك.'}
            </p>
          </div>
        </div>
      </div>

      <div className="px-5 text-center">
        <h2 className="text-3xl font-bold text-green-800">
          {langue === 'fr' ? 'Notre Histoire' : 'قصتنا'}
        </h2>
        <p className="mt-3 text-gray-800 lg:px-24">
          {langue === 'fr'
            ? 'Depuis plus de 40 ans, nous sélectionnons les meilleures épices à travers le monde pour offrir des produits naturels et de qualité. Antar est né de la passion pour la cuisine authentique et les saveurs exquises.'
            : 'منذ أكثر من 40 عامًا، نقوم باختيار أفضل التوابل من جميع أنحاء العالم لتقديم منتجات طبيعية وعالية الجودة. وُجدت "عنتر" نتيجة لشغفنا بالمأكولات التقليدية والنكهات الفريدة.'}
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-6 mt-10">
        <div className="text-center p-4 bg-gray-200 w-60 border rounded-lg shadow-md">
          <CheckCircle className="text-green-600 mx-auto" size={40} />
          <h3 className="font-bold mt-2">
            {langue === 'fr' ? 'Qualité Supérieure' : 'جودة عالية'}
          </h3>
          <p className="text-gray-600 text-sm">
            {langue === 'fr'
              ? 'Des épices rigoureusement sélectionnées.'
              : 'توابل مختارة بدقة.'}
          </p>
        </div>

        <div className="text-center p-4 bg-gray-200 w-60 border rounded-lg shadow-md">
          <Leaf className="text-green-600 mx-auto" size={40} />
          <h3 className="font-bold mt-2">
            {langue === 'fr' ? 'Respect de l\'Environnement' : 'الاحترام للبيئة'}
          </h3>
          <p className="text-gray-600 text-sm">
            {langue === 'fr'
              ? 'Des emballages éco-responsables.'
              : 'عبوات صديقة للبيئة.'}
          </p>
        </div>

        <div className="text-center p-4 bg-gray-200 w-60 border rounded-lg shadow-md">
          <Handshake className="text-green-600 mx-auto" size={40} />
          <h3 className="font-bold mt-2">
            {langue === 'fr' ? 'Commerce Équitable' : 'تجارة عادلة'}
          </h3>
          <p className="text-gray-600 text-sm">
            {langue === 'fr'
              ? 'Nous soutenons les petits producteurs.'
              : 'ندعم المنتجين الصغار.'}
          </p>
        </div>
      </div>

      <div className="mt-10 text-center">
        <h2 className="text-3xl font-bold text-green-800">
          {langue === 'fr' ? 'Ce que disent nos clients' : 'ماذا يقول عملائنا'}
        </h2>
        <div className="flex flex-wrap justify-center gap-6 mt-5">
          <div className="border p-4 bg-gray-200 rounded-lg shadow-md max-w-xs">
            <p>
              {langue === 'fr'
                ? '"Avec Antar Épices, un dîner que l’esprit aime."'
                : '"مع أنتر للتوابل، عشاء يحبه الخاطر."'}
            </p>
            <p className="mt-2 font-bold">— Mouad C.</p>
          </div>

          <div className="border p-4 bg-gray-200 rounded-lg shadow-md max-w-xs">
            <p>
              {langue === 'fr'
                ? '"Dieu bénisse ! Parmi les meilleures épices, un produit garanti."'
                : '"بارك الله فيك! من بين أفضل التوابل، منتج مضمون."'}
            </p>
            <p className="mt-2 font-bold">— Mohamad T.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Apropos
